import styled from "styled-components";

export const Styles = styled.div`
  .bg-blue-light {
    background-color: var(--inactive-color);
    color: #fff;
  }
  width: 100%;
  padding-inline: 3px;
`;
